import { useEffect } from 'react';
import { PRODUCT_NAME } from './brand.ts';

/** Every page names itself in the tab (WCAG 2.4.2): `<page> · MyMedMetrics`. */
export function useDocumentTitle(page: string): void {
  useEffect(() => {
    document.title = `${page} · ${PRODUCT_NAME}`;
  }, [page]);
}
